import React, { useCallback } from 'react'
import { SlotsFrameModule } from '@bcraft-frontend-lib/slots'

import SlotsIcon from 'components/slots/SlotsIcon/SlotsIcon'
import SlotsLayoutContent from 'components/slots/SlotsLayoutContent'

import { SlotPlace } from './redefinitions'

import './SlotsFrameLayout.scss'

export const SlotsFrameLayoutModule = () => {
  const successCallback = useCallback(() => {}, [])
  const errorCallback = useCallback(() => {}, [])

  return (
    <SlotsFrameModule<SlotPlace>
      type="multi"
      frameProps={{
        successCallback,
        errorCallback,
        renderSlotIcon: ({ slot, handleSlotAddFrame }) => (
          <SlotsIcon slot={slot} addFrame={handleSlotAddFrame} />
        ),
        renderSlotAddContent: ({ place, handleAddSlotFrame, filters }) => (
          <SlotsLayoutContent
            modal
            place={place}
            filters={filters}
            addFrame={handleAddSlotFrame}
          />
        ),
      }}
    />
  )
}
